import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { setAuth } from 'src/app/state/auth.actions';
import { ChildUserAccountForRegDto, ResultWrapper, SuperSignInDto } from '../dtos/dto';
import { take } from 'rxjs/operators';
import { setBusinessAccountParentKey } from 'src/app/state/business-account-parent-key.actions';
import { selectBusinessAccountParentKey } from 'src/app/state/business-account-parent-key.selector';
import { ConfigHelper } from './helpers/config.helper';



@Injectable({
  providedIn: 'root'
})
export class BusinessAccountService {
  parentAuth: AuthModel;

  constructor(
    private http: HttpClient,
    private configHelper: ConfigHelper,
    private store: Store,
    private router: Router
  ) { }
  getBusinessAccountCountry(): Observable<ResultWrapper<string>> {
    return this.http.get<ResultWrapper<string>>(this.configHelper.getApiUrl('/User/Account/BusinessAccountCountryName'));
  }

  getChildAccountsForReg(testSessionId: number, testTypeId: number): Observable<ResultWrapper<ChildUserAccountForRegDto[]>> {
    const params = new HttpParams()
      .set('testSessionId', testSessionId.toString())
      .set('testTypeId', testTypeId.toString());
    return this.http.get<ResultWrapper<ChildUserAccountForRegDto[]>>(this.configHelper.getApiUrl("User/Account/ChildAccountsForReg"), { params });
  }

  getAliasChildAccountToken(userAccountId: number): Observable<ResultWrapper<SuperSignInDto>> {
    return this.http.get<ResultWrapper<SuperSignInDto>>(this.configHelper.getApiUrl("User/Account/ChildAccount/AliasSignIn/") + userAccountId);
  }

  setTokenAndRedirectForAliasChildAccount(accessToken: string, childAccountEmail: string, parentAuth: AuthModel) {
    this.store.dispatch(setBusinessAccountParentKey({ businessAccountParentKey: parentAuth }));
    const childAuth = {
      access_token: accessToken,
      token_type: parentAuth.token_type,
      expires_in: parentAuth.expires_in,
      email: childAccountEmail
    };
    this.store.dispatch(setAuth({ auth: childAuth }));
    this.router.navigate(['my-account'])
      .then(() => {
        window.location.reload();
      });
  }

  navigateToParentAccountFromChild() {
    this.store.select(selectBusinessAccountParentKey).pipe(take(1))
      .subscribe(result => {
        this.parentAuth = result;
        this.store.dispatch(setAuth({ auth: this.parentAuth }));
        this.router.navigate(['my-account'])
          .then(() => {
            window.location.reload();
          });
      });
  }

  getNotificationConfig(): Observable<ResultWrapper<ConfigNotificationModel>> {
    return this.http.get<ResultWrapper<ConfigNotificationModel>>(this.configHelper.getApiUrl("User/Account/GetBusinessAccountNotificationConfig"));
  }

  saveNotificationConfig(configNotificationModel: ConfigNotificationModel) {
    return this.http.post(this.configHelper.getApiUrl("User/Account/SaveBusinessAccountNotificationConfig"), configNotificationModel);
  }
}
